// Landing page data: hero, books, and footer information

export interface BookData {
  id: string
  title: string
  author: string
  description: string
  image: string
}

export const BOOKS: BookData[] = [
  {
    id: 'work',
    title: 'Work Life',
    author: 'AI Engineering & Projects',
    description: 'Explore my journey in AI engineering, from machine learning systems to creative coding experiments. Building intelligent solutions that bridge technology and human experience.',
    image: 'https://covers.shakespeareandcompany.com/97818386/9781838661533.jpg',
  },
  {
    id: 'thoughts',
    title: 'Thoughts',
    author: 'Ideas & Musings',
    description: 'A collection of thoughts on technology, design, and life. Reflections on building with AI, designing for the future, and the art of simplicity in a complex world.',
    image: 'https://covers.shakespeareandcompany.com/97816377/9781637746028.jpg',
  },
  {
    id: 'photography',
    title: 'Photography',
    author: 'Visual Stories',
    description: 'Capturing moments through the lens. A visual journey exploring light, composition, and the stories that unfold in everyday life and extraordinary places.',
    image: 'https://covers.shakespeareandcompany.com/97802413/9780241371831.jpg',
  },
]

export const DEFAULT_STATE = {
  title: 'Mindscape',
  description: 'You might be here to take a peek into one of the static windows into my mind, so select one to begin with.',
}

export const LANDING_FOOTER = {
  left: ['Mindfulness', 'Presence'],
  center: 'Est. 2025 • Creative Development',
  right: ['34.0522° N', '118.2437° W'],
}
